import { Link } from "react-router-dom";
import { SENFULLY_APP_URL } from "../appConfig";
import logo from "../assets/brand/senfully-logo-horizontal-white.svg";
import "./styles/SiteFooter.css";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <img src={logo} alt="SENfully" width={163} height={40} />
          <p>Everyone who loves them, on the same page.</p>
        </div>

        <nav className="site-footer__column" aria-label="Explore">
          <h2 className="site-footer__heading">Explore</h2>
          <Link to="/features">Features</Link>
          <Link to="/how-it-works">How it works</Link>
          <Link to="/faq">FAQ</Link>
        </nav>

        <nav className="site-footer__column" aria-label="Get started">
          <h2 className="site-footer__heading">Get started</h2>
          <Link to="/get-senfully">Get SENfully</Link>
          <a href={SENFULLY_APP_URL}>Log in</a>
        </nav>

        <nav className="site-footer__column" aria-label="Company">
          <h2 className="site-footer__heading">Company</h2>
          <Link to="/contact">Contact us</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </div>

      <div className="container site-footer__legal">
        <p>© {new Date().getFullYear()} SENfully. All rights reserved.</p>
      </div>
    </footer>
  );
}
